import Header from '@/types/app/header';

export default class CustomerProduct {
  public static header: Header[] = [
    {
      text: 'Name',
      align: 'start',
      sortable: true,
      value: 'title',
      class: 'item-table-header item-table-header-name',
      width: ""
    },
    {
      text: 'Business Area',
      align: 'start',
      sortable: true,
      value: 'area',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    {
      text: 'Domicile',
      align: 'start',
      sortable: true,
      value: 'domicile',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    {
      text: 'Deadline',
      align: 'start',
      sortable: true,
      value: 'deadline',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    {
      text: 'Status',
      align: 'start',
      sortable: true,
      value: 'status',
      class: 'item-table-header item-table-header-amount',
      width: ""
    },
    {
      text: 'Published',
      align: 'start',
      sortable: true,
      value: 'published',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    {
      text: 'Investor Type',
      align: 'start',
      sortable: true,
      value: 'investorType',
      class: 'item-table-header item-table-header-refused',
      width: ""
    },
    
    {
      text: '',
      align: 'right',
      value: 'actions',
      sortable: false,
      class: null,
      width: ""
    }
  ];

  public static headerSubdocumentUsers: Header[] = [
    
    {
      text: 'Name',
      align: 'start',
      sortable: true,
      value: 'name',
      class: 'item-table-header item-table-header-name',
      width: ""
    },
    {
      text: 'E-mail',
      align: 'start',
      sortable: true,
      value: 'email',
      class: 'item-table-header item-table-header-email',
      width: ""
    },
    {
      text: 'Perfil Name',
      align: 'start',
      sortable: true,
      value: 'perfilName',
      class: 'item-table-header item-table-header-phone',
      width: ""
    },
    {
      text: 'Perfil Type',
      align: 'start',
      sortable: true,
      value: 'perfilType',
      class: 'item-table-header item-table-header-subdocument',
      width: ""
    },
    {
      text: 'Non US',
      align: 'start',
      sortable: true,
      value: 'nonUs',
      class: 'item-table-header item-table-header-subdocument',
      width: ""
    },
    {
      text: 'Status',
      align: 'start',
      sortable: true,
      value: 'status',
      class: 'item-table-header item-table-header-subdocument',
      width: ""
    }
  ];
}
